<script lang="ts">
    import { pfadstore, location, navstore } from "../store"
    import { get, writable } from "svelte/store"

    let breadcrumbs = []
    $: if ($pfadstore) breadcrumbs = getBreadcrumb($location.path)

    function getBreadcrumb(pfad: string) {
        const locationArray = pfad.split("/")
        locationArray.shift()

        let breadcrumb = []

        for (let index = 1; index < locationArray.length; index++) {
            let p = "/" + locationArray.slice(0, index + 1).join("/")

            const brcmb = Object.seal($pfadstore[p])
            brcmb?.name && breadcrumb.push(brcmb)
        }
        return breadcrumb
    }
</script>

<nav class="breadcrumbs" id="breadcrumb">
    <ul>
        <li><a href="/">Startseite</a></li>
        {#each breadcrumbs as item}
            <li><a href="{item.link ? item.link : item.path}">{item.name}</a></li>
        {/each}
    </ul>
</nav>
